// HelpContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface HelpContextType {
  help: boolean;
  toggleHelp: () => void;
}

const HelpContext = createContext<HelpContextType | undefined>(undefined);

export const HelpProvider: React.FC = ({ children }) => {
  const [help, setHelp] = useState<boolean>(false);

  const toggleHelp = () => {
    setHelp(prevHelp => !prevHelp);
  };

  return (
    <HelpContext.Provider value={{ help, toggleHelp }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = (): HelpContextType => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error("useHelp must be used within a HelpProvider");
  }
  return context;
};
